/**
 * Returns condition for aria attributes (e.g. `aria-disabled`, `aria-hidden`)
 * @param cond {any}
 * @returns "true" | undefined
 */
export const isAriaCondition = (cond?: boolean) => (cond ? 'true' : undefined);
